(function () {
  const QUESTION_TYPING_START_DELAY_MS = 120;
  const QUESTION_TYPING_CHARACTER_DELAY_MS = 24;
  const CONTENT_SLIDE_AFTER_TYPING_DELAY_MS = 120;
  const REVIEW_LIMIT = 88;
  const DEFAULT_RETENTION_OFFER = {
    type: "gift_card",
    amount_cents: 2500,
    currency: "USD",
    label: "$25 gift card",
  };
  const DEFAULT_SHIPPING_DETAILS = {
    order_status_label: "Unfulfilled",
    order_status_detail: "Preparing for shipment",
    estimated_delivery_label: "Not available yet",
    tracking_label: "Available once shipped",
    tracking_url: null,
    status_note: "We are still preparing your order and will share tracking once it ships.",
  };

  const imageUrls = {
    swing:
      "https://golfdaddy.com/cdn/shop/files/Somebody_swinging_b5ff45e3-6ab9-4eaf-8f0e-8346afd0274d.png?crop=center&height=1416&v=1780518900&width=1416",
    app:
      "https://golfdaddy.com/cdn/shop/files/App.png?crop=center&height=1416&v=1780518834&width=1416",
    box:
      "https://golfdaddy.com/cdn/shop/files/Box_1_7d125b82-d177-4c04-a313-d714251fc303.png?v=1779826597&width=1200",
  };

  const icons = {
    android:
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7.54 6.24 5.92 3.43a.75.75 0 0 1 1.3-.75l1.7 2.95a7.9 7.9 0 0 1 6.16 0l1.7-2.95a.75.75 0 0 1 1.3.75l-1.62 2.81A7.97 7.97 0 0 1 20 12v1H4v-1c0-2.34 1.01-4.45 3.54-5.76ZM8 10.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 14h14v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-5Zm-3 0h2v5H3a1 1 0 0 1-1-1v-4Zm18 0h2v4a1 1 0 0 1-1 1h-1v-5Z"></path></svg>',
    apple:
      '<svg viewBox="-2 1 23 24" fill="currentColor" aria-hidden="true"><path d="M16.2 2.2c.1 1.1-.32 2.16-1.02 2.95-.75.84-1.96 1.48-3.1 1.39-.13-1.07.38-2.2 1.06-2.96.78-.88 2.1-1.52 3.06-1.38Zm3.49 15.83c-.58 1.33-.86 1.92-1.61 3.1-1.05 1.62-2.54 3.65-4.38 3.67-1.64.02-2.06-1.07-4.28-1.05-2.22.01-2.69 1.08-4.33 1.06-1.84-.02-3.24-1.85-4.3-3.47-2.95-4.52-3.26-9.82-1.44-12.65 1.29-2.01 3.33-3.19 5.25-3.19 1.95 0 3.18 1.08 4.8 1.08 1.56 0 2.52-1.08 4.78-1.08 1.71 0 3.52.93 4.8 2.54-4.22 2.31-3.53 8.34.71 9.99Z"></path></svg>',
    arrowLeft:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg>',
    arrowRight:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>',
    arrowUp:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 7-7 7 7"></path><path d="M12 19V5"></path></svg>',
    badgeCheck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.78 4.78 4 4 0 0 1-6.74 0 4 4 0 0 1-4.78-4.78 4 4 0 0 1 0-6.75Z"></path><path d="m9 12 2 2 4-4"></path></svg>',
    calendar:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>',
    chart:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3v18h18"></path><path d="m19 9-5 5-4-4-3 3"></path></svg>',
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>',
    circle:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle></svg>',
    circleCheck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>',
    circleDollar:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path><path d="M12 18V6"></path></svg>',
    circleHelp:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 1 1 5.82 1c0 2-3 2-3 4"></path><path d="M12 17h.01"></path></svg>',
    flag:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 22V4"></path><path d="M4 4h11l-1 5 1 5H4"></path></svg>',
    gift:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"></path></svg>',
    globe:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M2 12h20"></path><path d="M12 2a15.3 15.3 0 0 1 0 20"></path><path d="M12 2a15.3 15.3 0 0 0 0 20"></path></svg>',
    house:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path><path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>',
    info:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>',
    landPlot:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 8 6-3 4 2v13l-6-3-8 3-6-3V4l6 3 4-2Z"></path><path d="M8 7v13"></path><path d="M16 5v12"></path></svg>',
    lightbulb:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 14c.2-1 .7-1.7 1.5-2.5a5 5 0 1 0-7 0C10.3 12.3 10.8 13 11 14"></path><path d="M9 18h6"></path><path d="M10 22h4"></path></svg>',
    message:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a4 4 0 0 1-4 4H7l-4 4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"></path></svg>',
    package:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m7.5 4.27 9 5.15"></path><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path><path d="m3.3 7 8.7 5 8.7-5"></path><path d="M12 22V12"></path></svg>',
    packageCheck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m16 16 2 2 4-4"></path><path d="m21 10-9-5-9 5 9 5 9-5Z"></path><path d="M3 10v6l9 5 2.5-1.39"></path><path d="M12 15v6"></path><path d="M21 10v2.5"></path></svg>',
    pencil:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"></path><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"></path></svg>',
    pause:
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 5h4v14H6z"></path><path d="M14 5h4v14h-4z"></path></svg>',
    play:
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7Z"></path></svg>',
    ruler:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m16 2 6 6L8 22l-6-6Z"></path><path d="m7.5 10.5 2 2"></path><path d="m10.5 7.5 2 2"></path><path d="m13.5 4.5 2 2"></path></svg>',
    star:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.53 2.32a.53.53 0 0 1 .94 0l2.9 5.88 6.49.94a.53.53 0 0 1 .29.9l-4.7 4.58 1.11 6.46a.53.53 0 0 1-.77.56L12 18.6l-5.8 3.04a.53.53 0 0 1-.76-.56l1.1-6.46-4.69-4.58a.53.53 0 0 1 .29-.9l6.49-.94Z"></path></svg>',
    tablet:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="10" height="14" x="3" y="8" rx="2"></rect><path d="M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"></path><path d="M8 18h.01"></path></svg>',
    target:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>',
    thumbsDown:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 14V2"></path><path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"></path></svg>',
    thumbsUp:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10v12"></path><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"></path></svg>',
    trophy:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 22h10a5 5 0 0 0-2.024-4.018A2 2 0 0 1 14 16.286V14.66"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M6 2h12v7a6 6 0 0 1-12 0Z"></path></svg>',
    truck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H2v14h2"></path><path d="M15 18H9"></path><path d="M19 18h3v-6h-3.5L16 8h-2"></path><circle cx="6.5" cy="18.5" r="2.5"></circle><circle cx="16.5" cy="18.5" r="2.5"></circle></svg>',
    volume:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>',
    volumeX:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line></svg>',
    upload:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><path d="m17 8-5-5-5 5"></path><path d="M12 3v12"></path></svg>',
    wrench:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.1-3.1a6 6 0 0 1-7.9 7.9l-6.6 6.6a2 2 0 0 1-2.8-2.8l6.6-6.6a6 6 0 0 1 7.9-7.9Z"></path></svg>',
    x:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>',
  };

  const helpfulOptions = [
    { id: "yes", label: "Yes", icon: "star" },
    { id: "somewhat", label: "Somewhat", icon: "thumbsUp" },
    { id: "no", label: "No", icon: "thumbsDown" },
  ];

  const supportOptions = [
    { id: "yes", label: "Yes, I would like assistance", icon: "thumbsUp" },
    { id: "no", label: "No, continue with return", icon: "thumbsDown" },
  ];

  const brandSlides = {
    cancellation: [
      {
        image:
          "https://golfdaddy.com/cdn/shop/files/Frame_1171274385_2_1.png?v=1763555585&width=1920",
        eyebrow: "Designed for improvement",
        title: "Real feedback in every session.",
        body:
          "GolfDaddy combines the mat, phone setup, and app feedback so practice feels easier to understand.",
      },
      {
        image:
          "https://golfdaddy.com/cdn/shop/files/Frame_1171274392_3_1.png?v=1763568164&width=1920",
        eyebrow: "Setup in seconds",
        title: "Practice from home.",
        body:
          "Use the setup indoors, outdoors, or wherever you have room to swing comfortably.",
      },
      {
        image:
          "https://golfdaddy.com/cdn/shop/files/Frame_1171274394_3_1.png?v=1763568212&width=1920",
        eyebrow: "Detailed analytics",
        title: "Know what to work on.",
        body:
          "Clear app feedback helps make each practice session more focused and useful.",
      },
    ],
    return: [
      {
        image: imageUrls.app,
        eyebrow: "Support first",
        title: "Small fixes can change the experience.",
        body:
          "Setup, calibration, lighting, and device checks can resolve many return reasons before a return is finalized.",
      },
      {
        image: imageUrls.swing,
        eyebrow: "Guided review",
        title: "One issue at a time.",
        body:
          "We collect the main return reason, show relevant guidance, and route warranty issues to support review.",
      },
      {
        image: imageUrls.box,
        eyebrow: "Replacement path",
        title: "Damaged items get handled carefully.",
        body:
          "Damaged, defective, or missing items can be reviewed for support or replacement before return processing.",
      },
    ],
  };

  const cancellationReasons = [
    {
      id: "negative_reviews",
      label: "I found information online that reduced my confidence",
      icon: "globe",
      resourceTitle: "GolfDaddy - Then vs Now",
      resourceDescription:
        "Review what has changed before making the final cancellation decision.",
      resourceQuestion: "How do you feel after reviewing these updates?",
      resourceOptions: [
        { id: "yes", label: "Much more confident", icon: "star" },
        { id: "somewhat", label: "Somewhat more confident", icon: "thumbsUp" },
        { id: "no", label: "My concerns remain", icon: "thumbsDown" },
      ],
    },
    {
      id: "product_fit",
      label: "I am concerned the product won't work for me",
      icon: "info",
      resourceTitle: "Built To Perform - Even For Skeptics",
      resourceDescription:
        "Review a performance story and sample outcome metrics before cancelling.",
      resourceQuestion: "Does this make you feel more confident about the product?",
      resourceOptions: helpfulOptions,
    },
    {
      id: "space",
      label: "I don't think I have enough space for the setup",
      icon: "house",
      resourceTitle: "GolfDaddy May Require Less Space Than You Think",
      resourceDescription:
        "Review compact setup examples before deciding space is a blocker.",
      resourceQuestion: "Does this setup seem possible in your space?",
      resourceOptions: [
        { id: "yes", label: "Yes", icon: "star" },
        { id: "somewhat", label: "Maybe", icon: "thumbsUp" },
        { id: "no", label: "No", icon: "thumbsDown" },
      ],
    },
    {
      id: "compatibility",
      label: "I'm unsure if my device is compatible",
      icon: "tablet",
      resourceTitle: "Let's Make Sure GolfDaddy Works With Your Setup",
      resourceDescription:
        "Review device support before deciding GolfDaddy is not compatible.",
      resourceQuestion:
        "Does your device appear to meet the compatibility requirements?",
      resourceOptions: [
        { id: "yes", label: "Yes", icon: "star" },
        { id: "somewhat", label: "Not sure", icon: "thumbsUp" },
        { id: "no", label: "No", icon: "thumbsDown" },
      ],
    },
    {
      id: "cost",
      label: "I'm not convinced the product is worth the price",
      icon: "circleDollar",
      resourceTitle: "See How Golfers Are Getting Results",
      resourceDescription:
        "Review customer result signals before deciding the value is not there.",
      resourceQuestion:
        "Does this help you better understand the value GolfDaddy provides?",
      resourceOptions: helpfulOptions,
    },
    {
      id: "shipping_delay",
      label: "The delivery timeline no longer works for me",
      icon: "truck",
      resourceTitle: "Shipping Update",
      resourceDescription:
        "View your latest shipping updates and estimated delivery timeline.",
      resourceQuestion:
        "If your order arrives within the estimated window, would you still like to cancel?",
      resourceOptions: [
        { id: "yes", label: "Yes", icon: "star" },
        { id: "somewhat", label: "Maybe", icon: "thumbsUp" },
        { id: "no", label: "No", icon: "thumbsDown" },
      ],
    },
    {
      id: "duplicate_product",
      label: "I received a similar product elsewhere",
      icon: "gift",
      resourceTitle: "We'd Love To Win You Back",
      resourceDescription:
        "Review a comparison-oriented note before choosing the similar product instead.",
      resourceQuestion: "Would a comparison guide help you decide?",
      resourceOptions: [
        { id: "yes", label: "Yes, send it", icon: "star" },
        { id: "somewhat", label: "Maybe later", icon: "thumbsUp" },
        { id: "no", label: "No thanks", icon: "thumbsDown" },
      ],
    },
    {
      id: "other",
      label: "Other",
      icon: "pencil",
      textStep: true,
    },
  ];

  const returnReasons = [
    {
      id: "accuracy",
      label: "I am afraid the product is not accurate enough for my needs",
      icon: "target",
      resourceTitle: "Let's Improve Accuracy Together",
      resourceDescription:
        "A few small tweaks usually unlock dramatically more accurate readings.",
      resourceQuestion: "Would you like assistance from our Support Team?",
      resourceOptions: supportOptions,
    },
    {
      id: "technical_issues",
      label: "I am having technical issues that prevent me from using the product",
      icon: "wrench",
      resourceTitle: "Let's Get You Back Up And Running",
      resourceDescription: "Most issues take less than 5 minutes to resolve.",
      resourceQuestion: "Would you like assistance from our Support Team?",
      resourceOptions: supportOptions,
    },
    {
      id: "compatibility",
      label: "I am not sure my device is fully compatible",
      icon: "tablet",
      resourceTitle: "Let's Make Sure GolfDaddy Works With Your Setup",
      resourceDescription:
        "Before proceeding with your return, let's confirm whether your device is supported.",
      resourceQuestion:
        "Does your device appear to meet the compatibility requirements?",
      resourceOptions: [
        { id: "yes", label: "Yes", icon: "thumbsUp" },
        { id: "maybe", label: "Not Sure", icon: "info" },
        { id: "no", label: "No", icon: "thumbsDown" },
      ],
    },
    {
      id: "space",
      label: "I do not have enough space to use the product comfortably",
      icon: "house",
      resourceTitle: "GolfDaddy May Require Less Space Than You Think",
      resourceDescription:
        "Customers set up successfully in rooms as small as 8 x 10 ft.",
      resourceQuestion: "Does this setup seem possible in your space?",
      resourceOptions: [
        { id: "yes", label: "Yes", icon: "thumbsUp" },
        { id: "maybe", label: "Maybe", icon: "info" },
        { id: "no", label: "No", icon: "thumbsDown" },
      ],
    },
    {
      id: "expectations",
      label: "The product did not meet my expectations",
      icon: "circleHelp",
      textPrompt: {
        title: "We'd Love To Learn More",
        description: "What specifically did not meet your expectations?",
        label: "What specifically did not meet your expectations?",
        placeholder: "Tell us what was missing or did not feel right...",
        resources: true,
      },
    },
    {
      id: "damaged",
      label: "My product arrived damaged, defective, or missing parts",
      icon: "package",
    },
    {
      id: "duplicate",
      label: "I received a duplicate product or gift",
      icon: "gift",
    },
    {
      id: "no_longer_need",
      label: "I no longer need the product",
      icon: "calendar",
      textPrompt: {
        title: "We'd Love To Learn More",
        description: "What changed after your purchase?",
        label: "What changed after your purchase?",
        placeholder: "Share what changed...",
      },
    },
    {
      id: "other",
      label: "Other",
      icon: "message",
      textPrompt: {
        title: "Please Tell Us More",
        description: "We read every response.",
        label: "Please Tell Us More",
        placeholder: "Share the details...",
      },
    },
  ];

  const returnItemOptions = [
    "Full GolfDaddy kit",
    "Main unit",
    "Tripod",
    "Phone mount",
    "Charging cable",
    "Accessories",
  ];

  const damageOptions = [
    "Main Unit",
    "Tripod",
    "Phone Mount",
    "Missing Parts / Accessories",
    "Physical Damage",
    "Other",
  ];

  const reviewDefaults = [
    {
      author: "Json",
      rating: 5,
      platform: "Trustpilot",
      quote:
        "Great customer service! Thank you Coach Mark and the tech team! I purchased the Golf Daddy product on Sunday and immediately ran into an issue opening the app. It was stuck on a loading screen when entering into any mode and the support bot escalated the issue to the customer support team. Based on some of the negative comments I had seen about the product, especially since it was the weekend, I honestly expected the issue to go unresolved for a while. However, Coach Mark reached out and reassured me that the team was aware of the issue and would work on a fix within 24-48 hours. Within that timeframe, Coach Mark followed up again to let me know the bug had been fixed. That really changed my view of the product and showed me that there is a dedicated team behind it that genuinely cares about the customer experience. Since then, I have been able to use the product, and so far my experience has been positive!",
    },
    {
      author: "Ty",
      rating: 5,
      platform: "Trustpilot",
      quote:
        "So impressed. The mat is durable and the app is super fun and actually helpful for my swing. I would say it is much more accurate than I expected.",
    },
    {
      author: "Daniel",
      rating: 5,
      platform: "Trustpilot",
      quote:
        "Had a great experience with their customer support. Had an issue in the app because I have an older phone and they were able to connect to it and resolve it. Really a 10/10 product and they have grown a lot since last year. The app is incredibly stable and provides accurate simulations. Their gamification makes this better than any other simulator in the world.",
    },
    {
      author: "Darlene Wheatley",
      rating: 5,
      platform: "Trustpilot",
      quote:
        "I placed an order for the indoor practice package and it was filled and shipped quickly. Unfortunately the package was mis-delivered by the Post Office. Working with Coach Nikki and Coach Mark, who were very responsive, we were able to solve my dilemma. I am happy with the high level of service and the product itself is great.",
    },
    {
      author: "Paula B.",
      rating: 5,
      platform: "Trustpilot",
      quote:
        "Father's Day Gifty. Ordered one for my husband and later one for our son-in-law. Had not received the codes for the first order and did not realize until I received it for the second order. Sent an email and within a few minutes Coach Mark had re-sent both codes. Very pleased so far!",
    },
  ];

  const DEFAULT_SUPPORTED_DEVICES = [
    "iPhone 17",
    "iPhone 16",
    "iPhone 15",
    "iPhone 14",
    "iPhone 13",
    "iPhone 12",
    "iPhone 11",
    "Samsung Galaxy S25",
    "Samsung Galaxy S25 Plus",
    "Samsung Galaxy S25 Edge",
    "Samsung Galaxy S25 Ultra",
    "Samsung Galaxy S24",
    "Samsung Galaxy S24 Plus",
    "Samsung Galaxy S24 Ultra",
    "Samsung Galaxy S23",
    "Samsung Galaxy S23 Plus",
    "Samsung Galaxy S23 Ultra",
    "Samsung Galaxy S23 FE",
    "Samsung Galaxy Z Fold6",
    "Samsung Galaxy Z Flip 6",
    "Samsung Galaxy Z Fold5",
    "Samsung Galaxy Z Flip 5",
    "Samsung Galaxy Z Fold4",
    "Samsung Galaxy Z Flip 4",
    "Samsung Galaxy Tab S9",
    "Samsung Galaxy Tab S9 Plus",
    "Samsung Galaxy Tab S9 Ultra",
    "Google Pixel 9",
    "Google Pixel 9 Pro",
    "Google Pixel 9 Pro Fold",
    "Google Pixel 8",
    "Google Pixel 8 Pro",
    "Google Pixel 7",
    "Google Pixel 7 Pro",
    "Google Pixel Fold",
    "Xiaomi 15",
    "Xiaomi 15 Pro",
    "Xiaomi 15 Ultra",
    "Xiaomi 14 Ultra",
    "Xiaomi 14 Pro",
    "Xiaomi 14",
    "Xiaomi 13 Ultra",
    "Xiaomi 13T Pro",
    "Xiaomi 13T",
    "Xiaomi Civi 4 Pro",
    "Xiaomi Civi 3",
    "Redmi K70",
    "Redmi K70 Pro",
    "Redmi K70E",
    "Redmi K60 Ultra",
    "Poco F5 Pro",
    "POCO X6 Pro",
    "Realme GT5",
    "Realme GT5 Pro",
    "Realme GT3",
    "Realme GT Neo 3T",
    "Realme GT2 Pro",
    "Realme 12 Pro+",
    "Asus ROG Phone 8 Pro",
    "Asus ROG Phone 8",
    "Asus ROG Phone 7",
    "Asus ROG Phone 7 Ultimate",
    "Asus Zenfone 11 Ultra",
    "Asus Zenfone 10",
    "ZTE Nubia Red Magic 9 Pro+",
    "ZTE Nubia Red Magic 9 Pro",
    "ZTE Nubia Red Magic 8S Pro+",
    "ZTE Nubia Red Magic 8S Pro",
    "ZTE Nubia Z60 Ultra",
    "OnePlus 13",
    "OnePlus 12",
    "OnePlus 12R",
    "OnePlus 11",
    "OnePlus 11R",
    "OnePlus Open",
    "iQOO 12",
    "iQOO 12 Pro",
    "iQOO 11",
    "iQOO 11 Pro",
    "iQOO 11s",
    "iQOO Neo9 Pro",
    "Vivo X100",
    "Vivo X100 Pro",
    "Vivo X90",
    "Vivo X90 Pro",
    "Vivo V30 Pro",
    "Honor Magic 6 Ultimate",
    "Honor Magic6",
    "Honor Magic 6 Pro",
    "Honor Magic6 RSR Porsche Design",
    "Honor Magic V2",
    "Honor Magic V2 RSR Porsche Design",
    "Oppo Find X7 Ultra",
    "Oppo Find X7",
    "Oppo Find N3",
    "Oppo Find N3 Flip",
    "Oppo Reno11 Pro",
    "Nothing Phone 3",
    "Nothing Phone 2",
  ];

  const surveyConfigs = {
    cancellation: {
      totalSteps: 5,
      brandTitle: "A quick check before your final decision.",
      brandKicker: "What customers notice",
      introTitle: "Before we process your cancellation request",
      introCopy:
        "Answer a few quick questions so we can understand what happened and show anything that may help before your final decision.",
      reasonTitle: "What is the primary reason for cancelling your order?",
      reasonDescription:
        "Choose the option that best matches what changed after purchase.",
      reasonEyebrow: "Help us understand",
      reasons: cancellationReasons,
    },
    return: {
      totalSteps: 6,
      brandTitle: "A quick review before your return.",
      brandKicker: "Return support",
      introTitle: null,
      introCopy: null,
      reasonTitle: "What is the primary reason for your return?",
      reasonDescription:
        "Choose the option that best matches your experience with the product.",
      reasonEyebrow: "Help us understand",
      reasons: returnReasons,
    },
  };

  const escapeHtml = value =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const getEnvelopeData = payload => (payload && payload.data ? payload.data : payload);

  const icon = name => icons[name] || icons.info;

  const truncateQuote = quote =>
    quote.length > REVIEW_LIMIT ? `${quote.slice(0, REVIEW_LIMIT).trimEnd()}...` : quote;

  class CustomerSurveyFlow extends HTMLElement {
    connectedCallback() {
      this.surveyType = this.dataset.surveyType === "return" ? "return" : "cancellation";
      this.config = surveyConfigs[this.surveyType];
      this.apiBase = this.normalizeApiBase(this.dataset.apiBase);
      this.token = this.getToken();
      this.logoSrc = this.dataset.logoSrc || "";
      this.logoAlt = this.dataset.logoAlt || "GolfDaddy";
      this.videoSrc = this.dataset.videoSrc || "";
      this.retentionOffer = DEFAULT_RETENTION_OFFER;
      this.spaceImageSources = (this.dataset.spaceImages || "")
        .split("|")
        .map(src => src.trim())
        .filter(Boolean);
      this.compatibilityIconSources = {
        apple: this.dataset.appleIconSrc || "",
        android: this.dataset.androidIconSrc || "",
      };
      this.supportedDevices = [...DEFAULT_SUPPORTED_DEVICES];
      this.prefersReducedMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.state = {
        step: this.surveyType === "return" ? "reason" : "loading",
        history: [],
        reasonId: null,
        resourceResponse: null,
        confidenceScore: null,
        otherText: "",
        notes: "",
        finalChoice: null,
        activeSlide: 0,
        spaceSlide: 0,
        videoPreview: null,
        videoDurationText: "",
        deviceModel: "",
        deviceResult: "",
        deviceSuggestionsOpen: false,
        shippingDetails: null,
        shippingLoading: false,
        shippingError: false,
        textDetail: "",
        damageTypes: [],
        damageDetails: "",
        damageFiles: [],
        damageResolution: null,
        returnItems: [],
        returnFiles: [],
        expandedReview: null,
        submitting: false,
        errorTitle: "",
        errorMessage: "",
        errorCanRetry: false,
      };
      this.seenMotionKeys = new Set();
      this.timers = [];
      this.spaceCarouselTimer = null;
      this.render();
      this.loadSupportedDevices();
      if (this.surveyType === "cancellation") return this.loadCancellationSurvey();
      this.setState({ step: "reason" });
      this.startBrandSlider();
    }

    disconnectedCallback() {
      this.clearTimers();
    }

    clearTimers() {
      this.timers.forEach(timer => window.clearTimeout(timer));
      this.timers = [];
      if (this.brandTimer) window.clearInterval(this.brandTimer);
      if (this.deviceSuggestionTimer) window.clearTimeout(this.deviceSuggestionTimer);
      this.stopSpaceCarousel();
    }

    normalizeApiBase(value) {
      const configured = value && value.trim() ? value.trim() : window.GD_API_BASE;
      return (configured || "").replace(/\/$/, "");
    }

    getToken() {
      const params = new URLSearchParams(window.location.search);
      return params.get("token") || "";
    }

    async loadSupportedDevices() {
      try {
        const response = await fetch("/pages/app", {
          headers: { Accept: "text/html" },
        });
        if (!response.ok) return;

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const devices = Array.from(
          parsed.querySelectorAll(
            ".devices-benchmark__row:not(.devices-benchmark__row--head) .devices-benchmark__device"
          )
        )
          .map(item => item.textContent.trim().replace(/\s+/g, " "))
          .filter(device => device && !/all other models/i.test(device));

        if (!devices.length) return;

        this.supportedDevices = Array.from(new Set(devices));
        this.updateDeviceOptionsDom();
      } catch (error) {
        this.updateDeviceOptionsDom();
      }
    }

    updateDeviceOptionsDom() {
      this.updateDeviceSuggestionsDom();
    }

    deviceSuggestionsHtml() {
      const suggestions = this.getDeviceSuggestions(this.state.deviceModel);
      if (!suggestions.length) {
        return '<p class="customer-survey__device-suggestion-empty">No supported device match found.</p>';
      }
      return suggestions
        .map(
          device => `
            <button class="customer-survey__device-suggestion" type="button" data-action="select-device-suggestion" data-value="${escapeHtml(device)}" role="option">
              ${escapeHtml(device)}
            </button>
          `
        )
        .join("");
    }

    normalizeDeviceName(value) {
      return String(value || "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "");
    }

    getSupportedDeviceMatch(value) {
      const normalized = this.normalizeDeviceName(value);
      if (!normalized) return null;
      return this.supportedDevices.find(
        device => this.normalizeDeviceName(device) === normalized
      );
    }

    getDeviceSuggestions(value) {
      const normalized = this.normalizeDeviceName(value);
      const source = normalized
        ? this.supportedDevices.filter(device =>
            this.normalizeDeviceName(device).includes(normalized)
          )
        : this.supportedDevices;
      return source.slice(0, 8);
    }

    openDeviceSuggestions() {
      this.state.deviceSuggestionsOpen = true;
      this.updateDeviceSuggestionsDom();
    }

    closeDeviceSuggestions() {
      this.state.deviceSuggestionsOpen = false;
      this.updateDeviceSuggestionsDom();
    }

    updateDeviceSuggestionsDom() {
      const list = this.querySelector("[data-device-suggestions]");
      const input = this.querySelector("#survey-device-model");
      if (input) {
        input.setAttribute("aria-expanded", this.state.deviceSuggestionsOpen ? "true" : "false");
      }
      if (!list) return;
      list.classList.toggle("is-open", this.state.deviceSuggestionsOpen);
      list.innerHTML = this.state.deviceSuggestionsOpen ? this.deviceSuggestionsHtml() : "";
      this.bindDeviceSuggestionEvents(list);
    }

    bindDeviceSuggestionEvents(root = this) {
      root.querySelectorAll("[data-action='select-device-suggestion']").forEach(element => {
        element.addEventListener("mousedown", event => event.preventDefault());
        element.addEventListener("click", event => {
          this.handleAction("select-device-suggestion", event.currentTarget);
        });
      });
    }

    async loadCancellationSurvey() {
      if (!this.apiBase) {
        this.renderState(
          "We could not load this request",
          "The API base URL is not configured for this theme."
        );
        return;
      }

      if (!this.token) {
        this.renderState(
          "This link is missing a token",
          "Please use the cancellation survey link sent by our support team."
        );
        return;
      }

      try {
        const response = await fetch(
          `${this.apiBase}/public/order-cancel-surveys/${encodeURIComponent(this.token)}`,
          { headers: { Accept: "application/json" } }
        );
        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          this.renderApiError(response.status, payload);
          return;
        }

        this.survey = getEnvelopeData(payload);
        this.retentionOffer = this.normalizeRetentionOffer(this.survey?.retention_offer);
        await this.loadCancellationRetentionOffer();

        if (this.survey?.status === "submitted") {
          this.setState({ finalChoice: this.survey.outcome || "submitted", step: "final" });
          return;
        }

        if (this.survey?.status === "expired") {
          this.renderState(
            "This survey link has expired",
            "Please contact support if you still need help with this order."
          );
          return;
        }

        this.setState({ step: "intro" });
        this.startBrandSlider();
      } catch (error) {
        this.renderState(
          "We could not load this request",
          "Please check your connection and try again."
        );
      }
    }

    async loadCancellationRetentionOffer() {
      try {
        const response = await fetch(
          `${this.apiBase}/public/order-cancel-surveys/${encodeURIComponent(this.token)}/retention-offer`,
          { headers: { Accept: "application/json" } }
        );
        if (!response.ok) return;
        const payload = await response.json().catch(() => ({}));
        this.retentionOffer = this.normalizeRetentionOffer(getEnvelopeData(payload));
      } catch (error) {
        this.retentionOffer = this.normalizeRetentionOffer(this.survey?.retention_offer);
      }
    }

    async loadCancellationShippingDetails() {
      if (!this.apiBase || !this.token || this.state.shippingLoading || this.state.shippingDetails) return;

      this.setState({ shippingLoading: true, shippingError: false });

      try {
        const response = await fetch(
          `${this.apiBase}/public/order-cancel-surveys/${encodeURIComponent(this.token)}/shipping`,
          { headers: { Accept: "application/json" } }
        );
        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(payload?.message || "Shipping details request failed");
        }

        this.setState({
          shippingDetails: this.normalizeShippingDetails(getEnvelopeData(payload)),
          shippingLoading: false,
          shippingError: false,
        });
      } catch (error) {
        this.setState({
          shippingDetails: DEFAULT_SHIPPING_DETAILS,
          shippingLoading: false,
          shippingError: true,
        });
      }
    }

    normalizeShippingDetails(details) {
      if (!details || typeof details !== "object") return DEFAULT_SHIPPING_DETAILS;
      return {
        order_status_label:
          typeof details.order_status_label === "string" && details.order_status_label.trim()
            ? details.order_status_label.trim()
            : DEFAULT_SHIPPING_DETAILS.order_status_label,
        order_status_detail:
          typeof details.order_status_detail === "string" && details.order_status_detail.trim()
            ? details.order_status_detail.trim()
            : DEFAULT_SHIPPING_DETAILS.order_status_detail,
        estimated_delivery_label:
          typeof details.estimated_delivery_label === "string" && details.estimated_delivery_label.trim()
            ? details.estimated_delivery_label.trim()
            : DEFAULT_SHIPPING_DETAILS.estimated_delivery_label,
        tracking_label:
          typeof details.tracking_label === "string" && details.tracking_label.trim()
            ? details.tracking_label.trim()
            : DEFAULT_SHIPPING_DETAILS.tracking_label,
        tracking_url:
          typeof details.tracking_url === "string" && details.tracking_url.trim()
            ? details.tracking_url.trim()
            : null,
        status_note:
          typeof details.status_note === "string" && details.status_note.trim()
            ? details.status_note.trim()
            : DEFAULT_SHIPPING_DETAILS.status_note,
      };
    }

    normalizeRetentionOffer(offer) {
      if (!offer || typeof offer !== "object") return DEFAULT_RETENTION_OFFER;
      const amountCents = Number(offer.amount_cents);
      return {
        type: typeof offer.type === "string" && offer.type.trim() ? offer.type : DEFAULT_RETENTION_OFFER.type,
        amount_cents: Number.isFinite(amountCents) && amountCents > 0 ? amountCents : DEFAULT_RETENTION_OFFER.amount_cents,
        currency:
          typeof offer.currency === "string" && offer.currency.trim()
            ? offer.currency.trim().toUpperCase()
            : DEFAULT_RETENTION_OFFER.currency,
        label:
          typeof offer.label === "string" && offer.label.trim()
            ? offer.label.trim()
            : DEFAULT_RETENTION_OFFER.label,
      };
    }

    getRetentionOfferLabel() {
      return this.retentionOffer?.label || DEFAULT_RETENTION_OFFER.label;
    }

    getRetentionOfferValue() {
      const offer = this.retentionOffer || DEFAULT_RETENTION_OFFER;
      if (offer.currency === "USD" && offer.amount_cents % 100 === 0) {
        return `$${offer.amount_cents / 100}`;
      }
      return offer.label;
    }

    renderApiError(status, payload) {
      const apiMessage =
        payload && payload.error && payload.error.message ? payload.error.message : payload.message;

      if (status === 404) {
        this.renderState(
          "This survey link was not found",
          "Please check that you opened the latest cancellation survey link."
        );
        return;
      }

      if (status === 410) {
        this.renderState(
          "This survey link has expired",
          "Please contact support if you still need help with this order."
        );
        return;
      }

      this.renderState(
        "We could not load this request",
        apiMessage || "Please try again in a moment."
      );
    }

    renderState(title, message) {
      this.setState({
        step: "state",
        errorTitle: title,
        errorMessage: message,
        errorCanRetry: false,
      });
    }

    startBrandSlider() {
      if (this.prefersReducedMotion) return;
      this.brandTimer = window.setInterval(() => {
        const slides = brandSlides[this.surveyType];
        this.state.activeSlide = (this.state.activeSlide + 1) % slides.length;
        const brand = this.querySelector("[data-survey-brand]");
        if (brand) {
          brand.innerHTML = this.renderBrandPanelInner();
          this.bindBrandEvents(brand);
        }
      }, 6500);
    }

    setState(patch) {
      const previousStep = this.state.step;
      const scrollArea = this.querySelector("[data-scroll-area]");
      const scrollTop = scrollArea ? scrollArea.scrollTop : 0;
      const nestedScrollPositions = Array.from(
        this.querySelectorAll(".customer-survey__reviews-track")
      ).map((element, index) => ({
        index,
        scrollLeft: element.scrollLeft,
      }));
      this.state = { ...this.state, ...patch };
      this.render({
        preserveScroll: this.state.step === previousStep,
        scrollTop,
        nestedScrollPositions,
      });
    }

    goTo(step) {
      this.setState({
        step,
        history: [...this.state.history, this.state.step],
      });
    }

    goBack() {
      const previous = this.state.history[this.state.history.length - 1];
      if (!previous) return;
      this.setState({
        step: previous,
        history: this.state.history.slice(0, -1),
      });
    }

    selectedReason() {
      return this.config.reasons.find(reason => reason.id === this.state.reasonId) || null;
    }

    currentStepNumber() {
      const step = this.state.step;
      if (this.surveyType === "cancellation") {
        if (step === "reason") return 1;
        if (step === "resource" || step === "other") return 2;
        if (step === "resourceThanks") return 3;
        if (step === "confidence") return 3;
        if (step === "notes") return 4;
        if (step === "offer") return 5;
        return 0;
      }

      if (step === "reason") return 1;
      if (["resource", "textDetail", "damage", "damageDetails", "damageResolution", "duplicateInfo"].includes(step)) return 2;
      if (step === "offer") return 3;
      if (step === "returnItems") return 4;
      if (step === "returnPhotos") return 5;
      if (step === "final") return 6;
      return 0;
    }

    progressHtml() {
      const stepNumber = this.currentStepNumber();
      if (!stepNumber || this.state.step === "final") return "";
      const percent = Math.round((stepNumber / this.config.totalSteps) * 100);
      return `
        <header class="customer-survey__progress">
          <button class="customer-survey__back" type="button" data-action="back" aria-label="Go back">${icon("arrowLeft")}</button>
          <div class="customer-survey__progress-main">
            <div class="customer-survey__progress-labels">
              <span>Step ${stepNumber} of ${this.config.totalSteps}</span>
              <span>${percent}% complete</span>
            </div>
            <div class="customer-survey__progress-track">
              <div class="customer-survey__progress-fill" style="width: ${percent}%"></div>
            </div>
          </div>
        </header>
      `;
    }

    logoHtml(location) {
      if (this.logoSrc) {
        return `<img class="customer-survey__logo-image" src="${escapeHtml(this.logoSrc)}" alt="${escapeHtml(this.logoAlt)}" loading="${location === "brand" ? "eager" : "lazy"}">`;
      }
      return '<span class="customer-survey__wordmark">GolfDaddy</span>';
    }

    renderBrandPanelInner() {
      const slides = brandSlides[this.surveyType];
      const slide = slides[this.state.activeSlide] || slides[0];
      return `
        <div class="customer-survey__brand-top">
          <div class="customer-survey__brand-logo">${this.logoHtml("brand")}</div>
          <h2 class="customer-survey__brand-title">${escapeHtml(this.config.brandTitle)}</h2>
        </div>
        <div class="customer-survey__brand-slider">
          <div class="customer-survey__brand-slider-head">
            <p class="customer-survey__brand-kicker">${escapeHtml(this.config.brandKicker)}</p>
            <div class="customer-survey__brand-navs">
              <button class="customer-survey__brand-nav" type="button" data-action="brand-prev" aria-label="Previous slide">${icon("arrowLeft")}</button>
              <button class="customer-survey__brand-nav" type="button" data-action="brand-next" aria-label="Next slide">${icon("arrowRight")}</button>
            </div>
          </div>
          <article class="customer-survey__brand-card" aria-label="${escapeHtml(slide.title)}">
            <div class="customer-survey__brand-media">
              <img src="${escapeHtml(slide.image)}" alt="${escapeHtml(slide.title)}" loading="lazy">
            </div>
            <div class="customer-survey__brand-copy">
              <p class="customer-survey__brand-eyebrow">${escapeHtml(slide.eyebrow)}</p>
              <h3 class="customer-survey__brand-slide-title">${escapeHtml(slide.title)}</h3>
              <p class="customer-survey__brand-slide-body">${escapeHtml(slide.body)}</p>
            </div>
          </article>
        </div>
      `;
    }

    brandPanelHtml() {
      return `<aside class="customer-survey__brand" data-survey-brand>${this.renderBrandPanelInner()}</aside>`;
    }

    render({ preserveScroll = false, scrollTop = 0, nestedScrollPositions = [] } = {}) {
      this.innerHTML = `
        <main class="customer-survey__root">
          <div class="customer-survey__shell">
            ${this.brandPanelHtml()}
            <section class="customer-survey__card">
              ${this.progressHtml()}
              <div class="customer-survey__scroll" data-scroll-area>
                ${this.stepHtml()}
              </div>
              ${this.footerHtml()}
            </section>
          </div>
        </main>
        ${this.state.videoPreview ? this.videoModalHtml() : ""}
      `;
      this.bindEvents();
      this.bindVideoThumbnails();
      this.bindVideoPlayer();
      this.startSpaceCarousel();
      this.loadVisibleDynamicContent();
      this.animateCurrentStep({ skipMotion: preserveScroll });
      if (preserveScroll) {
        this.restoreScrollPosition(scrollTop, nestedScrollPositions);
      }
      if (this.state.videoPreview) this.playVideoPreview();
    }

    loadVisibleDynamicContent() {
      if (
        this.surveyType === "cancellation" &&
        this.state.step === "resource" &&
        this.state.reasonId === "shipping_delay"
      ) {
        this.loadCancellationShippingDetails();
      }
    }

    restoreScrollPosition(scrollTop, nestedScrollPositions = []) {
      const restore = () => {
        const nextScrollArea = this.querySelector("[data-scroll-area]");
        if (nextScrollArea) nextScrollArea.scrollTop = scrollTop;
        nestedScrollPositions.forEach(({ index, scrollLeft }) => {
          const element = this.querySelectorAll(".customer-survey__reviews-track")[index];
          if (element) element.scrollLeft = scrollLeft;
        });
      };

      restore();
      window.requestAnimationFrame(restore);
    }

    formatVideoTime(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
      const totalSeconds = Math.floor(seconds);
      const minutes = Math.floor(totalSeconds / 60);
      const remainingSeconds = String(totalSeconds % 60).padStart(2, "0");
      return `${minutes}:${remainingSeconds}`;
    }

    formatVideoWatchText(seconds) {
      return `${this.formatVideoTime(seconds)} watch`;
    }

    bindVideoThumbnails() {
      this.querySelectorAll("[data-video-thumb]").forEach(video => {
        const updateDuration = () => {
          const duration = Number.isFinite(video.duration) ? video.duration : 0;
          if (!duration) return;
          const durationText = this.formatVideoWatchText(duration);
          this.state.videoDurationText = durationText;
          this.querySelectorAll("[data-video-duration-label]").forEach(element => {
            element.textContent = durationText;
            const card = element.closest("[data-action='open-video']");
            if (card) card.setAttribute("data-video-detail", durationText);
          });
        };

        if (video.readyState >= 1) {
          updateDuration();
          return;
        }
        video.addEventListener("loadedmetadata", updateDuration, { once: true });
      });
    }

    bindVideoPlayer() {
      const shell = this.querySelector("[data-video-shell]");
      const video = shell?.querySelector("[data-video-player]");
      const toggle = shell?.querySelector("[data-video-toggle]");
      const toggleIcon = shell?.querySelector("[data-video-toggle-icon]");
      const soundToggle = shell?.querySelector("[data-video-sound-toggle]");
      const soundIcon = shell?.querySelector("[data-video-sound-icon]");
      const seek = shell?.querySelector("[data-video-seek]");
      const currentTimeEl = shell?.querySelector("[data-video-current-time]");
      const durationTimeEl = shell?.querySelector("[data-video-duration-time]");

      if (!shell || !video || !toggle || !toggleIcon || !seek || !currentTimeEl || !durationTimeEl) return;

      let isSeeking = false;

      const updateToggle = () => {
        const isPaused = video.paused;
        shell.classList.toggle("is-playing", !isPaused);
        toggle.setAttribute("aria-label", isPaused ? "Play video" : "Pause video");
        toggle.classList.toggle("is-paused", isPaused);
        toggleIcon.innerHTML = icon(isPaused ? "play" : "pause");
      };

      const updateSound = () => {
        if (!soundToggle || !soundIcon) return;
        const isMuted = video.muted || video.volume === 0;
        soundToggle.setAttribute("aria-label", isMuted ? "Unmute video" : "Mute video");
        soundToggle.classList.toggle("is-muted", isMuted);
        soundIcon.innerHTML = icon(isMuted ? "volumeX" : "volume");
      };

      const unmuteVideo = () => {
        video.muted = false;
        if (video.volume === 0) video.volume = 1;
        updateSound();
      };

      const handleFullscreenChange = () => {
        const fullscreenElement =
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement;
        if (fullscreenElement === shell || fullscreenElement === video) {
          unmuteVideo();
        }
      };

      const updateTime = () => {
        const duration = Number.isFinite(video.duration) ? video.duration : 0;
        const currentTime = Number.isFinite(video.currentTime) ? video.currentTime : 0;
        const progress = duration ? (currentTime / duration) * 100 : Number(seek.value) || 0;
        currentTimeEl.textContent = this.formatVideoTime(currentTime);
        durationTimeEl.textContent = this.formatVideoTime(duration);
        if (!isSeeking) {
          seek.value = String(progress);
        }
        seek.style.setProperty("--video-progress", `${Math.max(0, Math.min(100, progress))}%`);
      };

      toggle.addEventListener("click", () => this.toggleVideoPlayback(video));
      video.addEventListener("click", () => this.toggleVideoPlayback(video));
      soundToggle?.addEventListener("click", event => {
        event.stopPropagation();
        video.muted = !video.muted;
        if (!video.muted && video.volume === 0) video.volume = 1;
        updateSound();
      });
      video.addEventListener("play", updateToggle);
      video.addEventListener("pause", updateToggle);
      video.addEventListener("volumechange", updateSound);
      shell.addEventListener("fullscreenchange", handleFullscreenChange);
      video.addEventListener("fullscreenchange", handleFullscreenChange);
      video.addEventListener("webkitbeginfullscreen", unmuteVideo);
      video.addEventListener("loadedmetadata", updateTime);
      video.addEventListener("timeupdate", updateTime);
      video.addEventListener("durationchange", updateTime);
      seek.addEventListener("input", () => {
        isSeeking = true;
        const duration = Number.isFinite(video.duration) ? video.duration : 0;
        if (duration) {
          video.currentTime = (Number(seek.value) / 100) * duration;
        }
        updateTime();
      });
      seek.addEventListener("change", () => {
        isSeeking = false;
        updateTime();
      });

      updateToggle();
      updateSound();
      updateTime();
    }

    toggleVideoPlayback(video = this.querySelector("[data-video-player]")) {
      if (!video) return;
      if (video.paused) {
        video.play().catch(() => {});
        return;
      }
      video.pause();
    }

    playVideoPreview() {
      window.requestAnimationFrame(() => {
        const video = this.querySelector("[data-video-player]");
        if (video) video.play().catch(() => {});
      });
    }

    stepHtml() {
      if (this.state.step === "loading") return this.loadingHtml();
      if (this.state.step === "state") return this.stateHtml();
      if (this.state.step === "intro") return this.introHtml();
      if (this.state.step === "reason") {
        return this.questionFrameHtml({
          motionKey: "reason",
          eyebrow: this.config.reasonEyebrow,
          title: this.config.reasonTitle,
          description: this.config.reasonDescription,
          body: this.reasonOptionsHtml(),
        });
      }
      if (this.state.step === "resource") return this.resourceStepHtml();
      if (this.state.step === "resourceThanks") return this.resourceThanksStepHtml();
      if (this.state.step === "other") return this.otherStepHtml();
      if (this.state.step === "confidence") return this.confidenceStepHtml();
      if (this.state.step === "notes") return this.notesStepHtml();
      if (this.state.step === "offer") return this.offerStepHtml();
      if (this.state.step === "textDetail") return this.returnTextDetailHtml();
      if (this.state.step === "damage") return this.damageStepHtml();
      if (this.state.step === "damageDetails") return this.damageDetailsStepHtml();
      if (this.state.step === "damageResolution") return this.damageResolutionStepHtml();
      if (this.state.step === "duplicateInfo") return this.duplicateInfoHtml();
      if (this.state.step === "returnItems") return this.returnItemsHtml();
      if (this.state.step === "returnPhotos") return this.returnPhotosHtml();
      if (this.state.step === "final") return this.finalHtml();
      return "";
    }

    loadingHtml() {
      return `
        <div class="customer-survey__state">
          <div class="customer-survey__loader" aria-hidden="true"></div>
          <h1 class="customer-survey__final-title">Loading your cancellation request...</h1>
        </div>
      `;
    }

    stateHtml() {
      const retryButton =
        this.state.errorCanRetry && this.state.finalChoice
          ? `<button class="customer-survey__continue customer-survey__final-retry" type="button" data-action="retry-submit">
              <span class="customer-survey__continue-hover" aria-hidden="true"></span>
              <span class="customer-survey__continue-text">Retry</span>
              <span class="customer-survey__continue-icon-wrapper">
                <span class="customer-survey__continue-icon">${icon("arrowRight")}</span>
              </span>
            </button>`
          : "";

      return `
        <div class="customer-survey__state">
          <div class="customer-survey__final-icon customer-survey__final-icon--error">${icon("info")}</div>
          <h1 class="customer-survey__final-title">${escapeHtml(this.state.errorTitle)}</h1>
          <p class="customer-survey__final-copy">${escapeHtml(this.state.errorMessage)}</p>
          ${retryButton}
        </div>
      `;
    }

    introHtml() {
      return `
        <div class="customer-survey__intro">
          <div class="customer-survey__intro-content">
            <div class="customer-survey__mobile-logo">${this.logoHtml("mobile")}</div>
            <h1 class="customer-survey__intro-title">${escapeHtml(this.config.introTitle)}</h1>
            <p class="customer-survey__intro-copy">${escapeHtml(this.config.introCopy)}</p>
          </div>
        </div>
      `;
    }

    questionFrameHtml({ motionKey, eyebrow, title, description, body }) {
      return `
        <div class="customer-survey__question-wrap" data-question-frame data-motion-key="${escapeHtml(motionKey)}" data-title="${escapeHtml(title)}">
          ${eyebrow ? `<p class="customer-survey__eyebrow">${escapeHtml(eyebrow)}</p>` : ""}
          <h1 class="customer-survey__question" aria-label="${escapeHtml(title)}">
            <span class="customer-survey__question-text" data-question-text></span>
          </h1>
        </div>
        <div class="customer-survey__content" data-slide-content>
          ${description ? `<p class="customer-survey__description">${escapeHtml(description)}</p>` : ""}
          ${body}
        </div>
      `;
    }

    reasonOptionsHtml() {
      return `<div class="customer-survey__option-list">
        ${this.config.reasons
          .map(reason =>
            this.optionHtml({
              id: reason.id,
              label: reason.label,
              iconName: reason.icon,
              selected: this.state.reasonId === reason.id,
              action: "select-reason",
            })
          )
          .join("")}
      </div>`;
    }

    optionHtml({
      id,
      label,
      iconName,
      selected,
      action,
      vertical = false,
      showCheck = true,
      meta = "",
    }) {
      return `
        <button class="customer-survey__option ${vertical ? "customer-survey__option--vertical" : ""} ${selected ? "is-selected" : ""}" type="button" data-action="${escapeHtml(action)}" data-value="${escapeHtml(id)}" aria-pressed="${selected ? "true" : "false"}">
          ${iconName ? `<span class="customer-survey__option-icon">${icon(iconName)}</span>` : ""}
          <span class="customer-survey__option-label">
            ${escapeHtml(label)}
            ${meta ? `<span class="customer-survey__option-meta">${escapeHtml(meta)}</span>` : ""}
          </span>
          ${showCheck ? `<span class="customer-survey__check" role="checkbox" aria-checked="${selected ? "true" : "false"}">${icon("check")}</span>` : ""}
        </button>
      `;
    }

    resourceStepHtml() {
      const reason = this.selectedReason();
      if (!reason) return "";
      const title = reason.resourceTitle || reason.resourceTitle;
      return this.questionFrameHtml({
        motionKey: title,
        eyebrow: this.surveyType === "return" ? this.resourceEyebrow(reason.id) : "A quick look",
        title,
        description: reason.resourceDescription || this.resourceDescription(title),
        body: `
          <div class="customer-survey__resource-stack">
            ${this.resourceDetailHtml(reason)}
            ${reason.resourceQuestion ? `
              <h2 class="customer-survey__section-title">${escapeHtml(reason.resourceQuestion)}</h2>
              <div class="customer-survey__option-grid">
                ${(reason.resourceOptions || helpfulOptions)
                  .map(option =>
                    this.optionHtml({
                      id: option.id,
                      label: option.label,
                      iconName: option.icon,
                      selected: this.state.resourceResponse === option.id,
                      action: "select-resource-response",
                      vertical: true,
                      showCheck: false,
                    })
                  )
                  .join("")}
              </div>
            ` : ""}
          </div>
        `,
      });
    }

    isPositiveResourceResponse() {
      if (this.surveyType !== "cancellation" || !this.state.resourceResponse) return false;
      const reason = this.selectedReason();
      if (!reason?.resourceOptions) return false;
      const firstOption = (reason.resourceOptions || helpfulOptions)[0];
      return firstOption?.id === this.state.resourceResponse;
    }

    resourceDescription(title) {
      const descriptions = {
        "GolfDaddy - Then vs Now":
          "A quick update on how GolfDaddy has improved since earlier customer feedback.",
        "Built To Perform - Even For Skeptics":
          "A quick customer story and performance snapshot for customers worried the product will not work well enough.",
        "Let's Make Sure GolfDaddy Works With Your Setup":
          "A compatibility check for customers unsure whether their phone or device will work.",
        "GolfDaddy May Require Less Space Than You Think":
          "Realistic setup examples for customers concerned they do not have enough room.",
        "See How Golfers Are Getting Results":
          "Value signals and coaching outcomes for customers reconsidering the price.",
        "Shipping Update":
          "A clear delivery-status view for customers whose timing no longer works.",
      };
      return descriptions[title] || "Helpful context before your final decision.";
    }

    resourceEyebrow(reasonId) {
      return {
        accuracy: "Helpful resources",
        technical_issues: "Troubleshooting",
        compatibility: "Compatibility",
        space: "Setup ideas",
      }[reasonId] || "Helpful resources";
    }

    resourceDetailHtml(reason) {
      if (reason.id === "negative_reviews") return this.recentImprovementsHtml();
      if (reason.id === "product_fit") return this.productFitHtml();
      if (reason.id === "space") return this.spaceHtml();
      if (reason.id === "compatibility") return this.compatibilityHtml();
      if (reason.id === "cost") return this.valueHtml();
      if (reason.id === "shipping_delay") return this.shippingHtml();
      if (reason.id === "duplicate_product") {
        return this.simpleCardHtml(
          "There are a lot of choices out there. GolfDaddy is built specifically for serious at-home feedback, with guided setup and a focused practice experience."
        );
      }
      if (reason.id === "other") {
        return this.simpleCardHtml(
          "Thanks for sharing. Choose the closest option below so the team can understand what happened before the request is finalized."
        );
      }
      if (reason.id === "accuracy") return this.returnAccuracyHtml();
      if (reason.id === "technical_issues") return this.returnTechnicalHtml();
      return this.simpleCardHtml("Review the guidance below before continuing.");
    }

    videoSideHtml({ title, subtitle, thumbnailSrc, sideTitle, cards }) {
      return `
        <section class="customer-survey__resource-video-row">
          ${this.videoCardHtml({ title, subtitle, thumbnailSrc })}
          <div class="customer-survey__side">
            ${sideTitle ? `<p class="customer-survey__section-title">${escapeHtml(sideTitle)}</p>` : ""}
            ${cards.join("")}
          </div>
        </section>
      `;
    }

    videoCardHtml({ title, subtitle, thumbnailSrc }) {
      const videoTitle = "How to get started?";
      const displaySubtitle = this.state.videoDurationText || subtitle;

      return `
        <button class="customer-survey__video-card" type="button" data-action="open-video" data-video-title="${escapeHtml(videoTitle)}" data-video-detail="${escapeHtml(displaySubtitle)}" data-video-src="${escapeHtml(this.videoSrc)}" aria-label="Play ${escapeHtml(videoTitle)} video preview">
          ${
            this.videoSrc
              ? `<video class="customer-survey__video-thumb" src="${escapeHtml(this.videoSrc)}" autoplay loop muted playsinline preload="metadata" aria-hidden="true" data-video-thumb></video>`
              : `<img src="${escapeHtml(thumbnailSrc)}" alt="" loading="lazy">`
          }
          <span class="customer-survey__play">${icon("play")}</span>
          <span class="customer-survey__video-copy">
            <span class="customer-survey__video-title">${escapeHtml(videoTitle)}</span>
            <span class="customer-survey__video-subtitle" data-video-duration-label>${escapeHtml(displaySubtitle)}</span>
          </span>
        </button>
      `;
    }

    spaceCarouselHtml() {
      const images = this.spaceImageSources.length
        ? this.spaceImageSources
        : [imageUrls.box];
      const activeIndex = Math.min(this.state.spaceSlide, images.length - 1);
      const activeSrc = images[activeIndex];
      const labels = ["Small room setup", "Garage setup", "Basement setup"];

      return `
        <section class="customer-survey__space-carousel" aria-label="Compact GolfDaddy setup examples">
          <div class="customer-survey__space-carousel-frame">
            <button class="customer-survey__space-carousel-arrow customer-survey__space-carousel-arrow--prev" type="button" data-action="space-carousel-prev" aria-label="Previous space example">
              ${icon("arrowLeft")}
            </button>
            <img class="customer-survey__space-carousel-image" src="${escapeHtml(activeSrc)}" alt="${escapeHtml(labels[activeIndex] || "GolfDaddy setup example")}" loading="lazy">
            <button class="customer-survey__space-carousel-arrow customer-survey__space-carousel-arrow--next" type="button" data-action="space-carousel-next" aria-label="Next space example">
              ${icon("arrowRight")}
            </button>
            <div class="customer-survey__space-carousel-controls">
              <div class="customer-survey__space-carousel-dots" aria-label="Space example slides">
                ${images
                  .map(
                    (_, index) => `
                      <button
                        class="customer-survey__space-carousel-dot${index === activeIndex ? " is-active" : ""}"
                        type="button"
                        data-action="space-carousel-dot"
                        data-value="${index}"
                        aria-label="Show space example ${index + 1}"
                        aria-pressed="${index === activeIndex ? "true" : "false"}"
                      ></button>
                    `
                  )
                  .join("")}
              </div>
            </div>
          </div>
        </section>
      `;
    }

    spaceCarouselSideHtml({ sideTitle, cards }) {
      return `
        <section class="customer-survey__resource-video-row customer-survey__resource-video-row--space">
          ${this.spaceCarouselHtml()}
          <div class="customer-survey__side">
            ${sideTitle ? `<p class="customer-survey__section-title">${escapeHtml(sideTitle)}</p>` : ""}
            ${cards.join("")}
          </div>
        </section>
      `;
    }

    sideCardHtml({ iconName = "badgeCheck", title, subtitle = "" }) {
      return `
        <article class="customer-survey__side-card">
          <div class="customer-survey__side-item">
            <span class="customer-survey__side-icon">${icon(iconName)}</span>
            <div class="customer-survey__side-text">
              <p class="customer-survey__side-title">${escapeHtml(title)}</p>
              ${subtitle ? `<span class="customer-survey__side-subtitle" title="${escapeHtml(subtitle)}">${escapeHtml(subtitle)}</span>` : ""}
            </div>
          </div>
        </article>
      `;
    }

    metricCardHtml({ iconName, value, label }) {
      return `
        <article class="customer-survey__metric-card">
          <span class="customer-survey__metric-icon">${icon(iconName)}</span>
          <div>
            <p class="customer-survey__metric-value">${escapeHtml(value)}</p>
            <p class="customer-survey__metric-label">${escapeHtml(label)}</p>
          </div>
        </article>
      `;
    }

    recentImprovementsHtml() {
      return `
        ${this.videoSideHtml({
          title: "GolfDaddy: Then vs Now",
          subtitle: "2 min watch",
          thumbnailSrc: imageUrls.swing,
          sideTitle: "Recent improvements",
          cards: ["Improved accuracy", "Better app stability", "Faster support", "Easier setup"].map(title =>
            this.sideCardHtml({ iconName: "badgeCheck", title })
          ),
        })}
        <section class="customer-survey__comparison-grid">
          <h2 class="customer-survey__resource-heading">What changed recently</h2>
          ${this.comparisonColumnHtml({
            title: "Then (2024)",
            tone: "muted",
            items: ["Limited accuracy", "Occasional crashes", "Slow support"],
          })}
          ${this.comparisonColumnHtml({
            title: "Now (2026)",
            tone: "strong",
            items: ["+/-1 yd accuracy", "Rock-solid stability", "Avg 12-min reply"],
          })}
        </section>
        ${this.reviewCarouselHtml()}
      `;
    }

    productFitHtml() {
      return `
        ${this.videoSideHtml({
          title: "Beginner to Bogey Golfer",
          subtitle: "Real customer story - 3 min",
          thumbnailSrc: imageUrls.app,
          sideTitle: "Customer outcomes",
          cards: [
            this.metricCardHtml({ iconName: "target", value: "+8", label: "Avg handicap drop" }),
            this.metricCardHtml({ iconName: "trophy", value: "94%", label: "Recommend to a friend" }),
          ],
        })}
        ${this.reviewCarouselHtml()}
        <section class="customer-survey__resource-card">
          <p class="customer-survey__resource-heading">Before &amp; After</p>
          <div class="customer-survey__comparison-grid" style="margin-top: 12px;">
            <article class="customer-survey__comparison-card">
              <p class="customer-survey__resource-heading">Before</p>
              <p class="customer-survey__side-title" style="margin-top: 8px;">Handicap 26 - Inconsistent</p>
            </article>
            <article class="customer-survey__comparison-card">
              <p class="customer-survey__resource-heading">After 90 days</p>
              <p class="customer-survey__side-title" style="margin-top: 8px;">Handicap 17 - Consistent</p>
            </article>
          </div>
        </section>
      `;
    }

    spaceHtml() {
      return `
        ${this.spaceCarouselSideHtml({
          sideTitle: "Space examples",
          cards: [
            this.sideCardHtml({ iconName: "house", title: "Small Room" }),
            this.sideCardHtml({ iconName: "house", title: "Garage" }),
            this.sideCardHtml({ iconName: "house", title: "Basement" }),
          ],
        })}
        ${this.reviewCarouselHtml()}
      `;
    }

    compatibilityHtml() {
      return `
        <section class="customer-survey__compat-grid">
          ${this.compatCardHtml({ label: "iPhone", value: "iOS 16+ devices", iconName: "apple", tone: "apple" })}
          ${this.compatCardHtml({ label: "Android", value: "11+ devices", iconName: "android", tone: "android" })}
        </section>
        ${this.deviceCheckHtml()}
      `;
    }

    compatCardHtml({ label, value, iconName, tone }) {
      const iconSrc = this.compatibilityIconSources?.[tone] || "";
      return `
        <article class="customer-survey__compat-card">
          <span class="customer-survey__compat-icon customer-survey__compat-icon--${escapeHtml(tone)}">
            ${
              iconSrc
                ? `<img src="${escapeHtml(iconSrc)}" alt="" loading="lazy">`
                : icon(iconName)
            }
          </span>
          <div>
            <p class="customer-survey__compat-label">${escapeHtml(label)}</p>
            <p class="customer-survey__compat-value">${escapeHtml(value)}</p>
          </div>
        </article>
      `;
    }

    deviceCheckHtml() {
      return `
        <section class="customer-survey__device-card">
          <label class="customer-survey__resource-heading" for="survey-device-model">Check your device</label>
          <div class="customer-survey__device-input-wrap">
            <input class="customer-survey__input" id="survey-device-model" type="text" value="${escapeHtml(this.state.deviceModel)}" data-action="device-model" autocomplete="off" placeholder="e.g. iPhone 14, Pixel 8..." aria-autocomplete="list" aria-expanded="${this.state.deviceSuggestionsOpen ? "true" : "false"}" aria-controls="survey-device-suggestions">
            <span class="customer-survey__device-select-arrow" aria-hidden="true"></span>
          </div>
          <div class="customer-survey__device-suggestions ${this.state.deviceSuggestionsOpen ? "is-open" : ""}" id="survey-device-suggestions" data-device-suggestions role="listbox">
            ${this.state.deviceSuggestionsOpen ? this.deviceSuggestionsHtml() : ""}
          </div>
          <button class="customer-survey__device-action" type="button" data-action="check-device" ${this.state.deviceModel.trim() ? "" : "disabled"}>
            <span class="customer-survey__device-action-inner">
              <span class="customer-survey__device-action-text">Check compatibility</span>
              <span class="customer-survey__device-action-icon" aria-hidden="true">
                <span class="customer-survey__device-action-arrow">${icon("arrowRight")}</span>
              </span>
            </span>
          </button>
          ${this.state.deviceResult ? `<p class="customer-survey__device-result" role="status">${escapeHtml(this.state.deviceResult)}</p>` : ""}
          <p class="customer-survey__device-help">
            <span class="customer-survey__device-help-icon">${icon("info")}</span>
            <span>Most devices from the last 4 years are supported.</span>
          </p>
        </section>
      `;
    }

    valueHtml() {
      return `
        ${this.videoSideHtml({
          title: "Member Success Stories",
          subtitle: "3 golfers, 3 transformations - 4 min",
          thumbnailSrc: imageUrls.swing,
          sideTitle: "Measured results",
          cards: [
            this.metricCardHtml({ iconName: "chart", value: "87%", label: "Practice more frequently" }),
            this.metricCardHtml({ iconName: "target", value: "82%", label: "Report improved consistency" }),
            this.metricCardHtml({ iconName: "circleDollar", value: "3.4x", label: "Practice sessions per week" }),
          ],
        })}
        ${this.chatCardHtml()}
      `;
    }

    chatCardHtml() {
      return `
        <section class="customer-survey__chat-card">
          <div class="customer-survey__chat-head">
            <span class="customer-survey__chat-icon">${icon("message")}</span>
            <div>
              <p class="customer-survey__resource-heading">Coaching success</p>
              <p class="customer-survey__chat-subtitle">Coach Riley</p>
            </div>
          </div>
          <div class="customer-survey__messages">
            <p class="customer-survey__message customer-survey__message--left">Your swing path has improved significantly over the last month.</p>
            <p class="customer-survey__message customer-survey__message--right">This is the first time I have consistently broken 90</p>
            <p class="customer-survey__message customer-survey__message--left">Keep it up - let's work on tempo next week.</p>
          </div>
        </section>
      `;
    }

    shippingHtml() {
      const shipping = this.state.shippingDetails || DEFAULT_SHIPPING_DETAILS;
      const rows = [
        {
          iconName: "package",
          label: "Order status",
          value: shipping.order_status_detail,
          meta: shipping.order_status_label,
        },
        {
          iconName: "calendar",
          label: "Estimated delivery",
          value: shipping.estimated_delivery_label,
        },
        {
          iconName: "truck",
          label: "Tracking",
          value: shipping.tracking_label,
          url: shipping.tracking_url,
        },
      ];
      return `
        <section class="customer-survey__shipping-stack">
          ${
            this.state.shippingLoading
              ? `<p class="customer-survey__shipping-loading">Loading your latest shipping details...</p>`
              : ""
          }
          ${rows
            .map(row => `
              <div class="customer-survey__shipping-row">
                <span class="customer-survey__side-icon">${icon(row.iconName)}</span>
                <div>
                  <p class="customer-survey__resource-heading">${escapeHtml(row.label)}</p>
                  ${
                    row.url
                      ? `<a class="customer-survey__shipping-value customer-survey__shipping-link" href="${escapeHtml(row.url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(row.value)}</a>`
                      : `<p class="customer-survey__shipping-value">${escapeHtml(row.value)}</p>`
                  }
                  ${row.meta ? `<p class="customer-survey__shipping-meta">${escapeHtml(row.meta)}</p>` : ""}
                </div>
              </div>
            `)
            .join("")}
        </section>
        <section class="customer-survey__status-note">
          <span class="customer-survey__status-icon">${icon(this.state.shippingError ? "info" : "check")}</span>
          <p>${escapeHtml(shipping.status_note)}</p>
        </section>
      `;
    }

    returnAccuracyHtml() {
      return `
        ${this.videoSideHtml({
          title: "Camera positioning walkthrough",
          subtitle: "2 min",
          thumbnailSrc: imageUrls.app,
          sideTitle: "Accuracy setup tips",
          cards: [
            this.sideCardHtml({ iconName: "ruler", title: "Place camera 7-8 ft from hitting area" }),
            this.sideCardHtml({ iconName: "lightbulb", title: "Soft, indirect light works best" }),
          ],
        })}
        <section class="customer-survey__comparison-grid">
          <h2 class="customer-survey__resource-heading">Before &amp; After accuracy examples</h2>
          ${this.comparisonColumnHtml({ title: "Incorrect", tone: "muted", items: ["Backlit camera", "Glare reduces tracking quality"] })}
          ${this.comparisonColumnHtml({ title: "Optimized", tone: "strong", items: ["Front-lit, centered", "Clear, consistent reads"] })}
        </section>
        ${this.reviewCarouselHtml()}
      `;
    }

    returnTechnicalHtml() {
      return this.videoSideHtml({
        title: "App crashing or freezing",
        subtitle: "2 min",
        thumbnailSrc: imageUrls.app,
        sideTitle: "Common technical solutions",
        cards: [
          this.sideCardHtml({ iconName: "arrowUp", title: "Update to the latest app version" }),
          this.sideCardHtml({ iconName: "message", title: "Get help from our Support Team" }),
        ],
      });
    }

    comparisonColumnHtml({ title, tone, items }) {
      return `
        <article class="customer-survey__comparison-card customer-survey__comparison-card--${escapeHtml(tone)}">
          <p class="customer-survey__resource-heading">${escapeHtml(title)}</p>
          <ul>
            ${items.map(item => `<li>${icon(tone === "strong" ? "check" : "circle")}<span>${escapeHtml(item)}</span></li>`).join("")}
          </ul>
        </article>
      `;
    }

    reviewCarouselHtml() {
      const reviews = reviewDefaults;
      return `
        <section class="customer-survey__reviews">
          <div>
            <p class="customer-survey__reviews-eyebrow">Customer reviews</p>
            <h2 class="customer-survey__resource-heading" style="margin-top: 4px;">Ratings from real golfers</h2>
          </div>
          <div class="customer-survey__reviews-track" tabindex="0" aria-label="Customer reviews">
            ${reviews
              .map((review, index) => {
                const key = `${review.platform}-${review.author}-${index}`;
                const isExpanded = this.state.expandedReview === key;
                const canExpand = review.quote.length > REVIEW_LIMIT;
                const displayQuote = canExpand && !isExpanded ? truncateQuote(review.quote) : review.quote;
                const rating = Number.isInteger(review.rating) ? String(review.rating) : review.rating.toFixed(1);
                return `
                  <article class="customer-survey__review-card">
                    <div class="customer-survey__review-top">
                      <p class="customer-survey__rating" aria-label="${rating} out of 5 rating">${rating}/5</p>
                      <span class="customer-survey__badge">${icon("check")} ${escapeHtml(review.platform)}</span>
                    </div>
                    <p class="customer-survey__quote">&quot;${escapeHtml(displayQuote)}&quot;${
                      canExpand
                        ? ` <button class="customer-survey__link" type="button" data-action="toggle-review" data-value="${escapeHtml(key)}">${isExpanded ? "Show less" : "Read more"}</button>`
                        : ""
                    }</p>
                    <p class="customer-survey__review-author">${escapeHtml(review.author)}</p>
                  </article>
                `;
              })
              .join("")}
          </div>
        </section>
      `;
    }

    simpleCardHtml(text) {
      return `<section class="customer-survey__simple-card">${escapeHtml(text)}</section>`;
    }

    otherStepHtml() {
      return this.questionFrameHtml({
        motionKey: "other",
        eyebrow: "A little more context",
        title: "Tell Us A Little More",
        description: "Please tell us more about what led to your decision.",
        body: `
          <label class="customer-survey__field-label" for="other-reason">Tell us more about what led to your decision</label>
          <textarea class="customer-survey__textarea" id="other-reason" data-action="other-text" rows="6" placeholder="Share the main reason...">${escapeHtml(this.state.otherText)}</textarea>
        `,
      });
    }

    confidenceStepHtml() {
      return this.questionFrameHtml({
        motionKey: "confidence",
        eyebrow: "Confidence",
        title: "Before cancelling, how confident were you that GolfDaddy would work for you?",
        description: "1 means not confident, 5 means very confident.",
        body: `
          <div class="customer-survey__score-grid">
            ${[1, 2, 3, 4, 5]
              .map(score => `<button class="customer-survey__score ${this.state.confidenceScore === score ? "is-selected" : ""}" type="button" data-action="select-score" data-value="${score}" aria-pressed="${this.state.confidenceScore === score ? "true" : "false"}">${score}</button>`)
              .join("")}
          </div>
        `,
      });
    }

    notesStepHtml() {
      return this.questionFrameHtml({
        motionKey: "notes",
        eyebrow: "Final note",
        title: "Is there anything else you'd like us to know?",
        description: "Optional, but helpful for our support and product teams.",
        body: `<textarea class="customer-survey__textarea" data-action="notes-text" rows="6" placeholder="Add anything else...">${escapeHtml(this.state.notes)}</textarea>`,
      });
    }

    resourceThanksStepHtml() {
      return this.questionFrameHtml({
        motionKey: "resource-thanks",
        eyebrow: "Thanks for reviewing",
        title: "Thanks for taking another look",
        description:
          "We're glad the resources were helpful for you. You can keep your order now, or continue with the cancellation request if that still feels right.",
        body: `
          <div class="customer-survey__option-list">
            <button class="customer-survey__option" type="button" data-action="final-choice" data-value="keep">
              <span class="customer-survey__option-icon">${icon("thumbsUp")}</span>
              <span class="customer-survey__option-label">Keep My Order</span>
              <span class="customer-survey__check" role="checkbox" aria-checked="false">${icon("check")}</span>
            </button>
            <button class="customer-survey__option" type="button" data-action="resource-thanks-cancel">
              <span class="customer-survey__option-icon">${icon("arrowRight")}</span>
              <span class="customer-survey__option-label">Continue with Cancellation</span>
              <span class="customer-survey__check" role="checkbox" aria-checked="false">${icon("check")}</span>
            </button>
          </div>
        `,
      });
    }

    offerStepHtml() {
      const isReturn = this.surveyType === "return";
      const retentionOfferLabel = this.getRetentionOfferLabel();
      const retentionOfferValue = this.getRetentionOfferValue();
      return this.questionFrameHtml({
        motionKey: "offer",
        eyebrow: "One last option",
        title: "Before You Make Your Final Decision",
        description: isReturn
          ? "If you're willing to keep your product, we'd be happy to offer a 10% partial refund as a goodwill gesture."
          : `If you're willing to give GolfDaddy a try, we'd be happy to offer a ${retentionOfferLabel} as a goodwill gesture.`,
        body: `
          <div class="customer-survey__offer-list">
            <button class="customer-survey__gift-card" type="button" data-action="final-choice" data-value="retain">
              <span class="customer-survey__gift-value">${isReturn ? "10%" : escapeHtml(retentionOfferValue)}</span>
              <span class="customer-survey__gift-inner">
                <span class="customer-survey__gift-icon">${icon(isReturn ? "circleDollar" : "gift")}</span>
                <span class="customer-survey__gift-eyebrow">${isReturn ? "Partial refund offer" : "Gift card offer"}</span>
                <span class="customer-survey__gift-title">${isReturn ? "Keep Product & Receive a 10% Refund" : `Keep My Order & Receive a ${escapeHtml(retentionOfferLabel)}`}</span>
                <span class="customer-survey__gift-copy">${isReturn ? "Keep your product and record the retention choice for the next backend phase." : "Continue with the order and record the retention choice for the next backend phase."}</span>
              </span>
            </button>
            <button class="customer-survey__decline" type="button" data-action="final-choice" data-value="${isReturn ? "return" : "cancel"}">
              <span class="customer-survey__decline-icon">${icon("arrowRight")}</span>
              <span class="customer-survey__decline-title">${isReturn ? "Continue With Return" : "Continue With Cancellation"}</span>
              <span class="customer-survey__decline-copy">${isReturn ? "Record the return intent without taking a real order action yet." : "Record the cancellation intent without taking a real order action yet."}</span>
            </button>
          </div>
        `,
      });
    }

    returnTextDetailHtml() {
      const reason = this.selectedReason();
      const prompt = reason && reason.textPrompt ? reason.textPrompt : null;
      if (!prompt) return "";
      return this.questionFrameHtml({
        motionKey: `text-${reason.id}`,
        eyebrow: "A little more context",
        title: prompt.title,
        description: prompt.description,
        body: `
          ${prompt.resources ? this.expectationResourcesHtml() : ""}
          <label class="customer-survey__field-label" for="return-text-detail">${escapeHtml(prompt.label)}</label>
          <textarea class="customer-survey__textarea" id="return-text-detail" data-action="text-detail" rows="6" placeholder="${escapeHtml(prompt.placeholder)}">${escapeHtml(this.state.textDetail)}</textarea>
        `,
      });
    }

    expectationResourcesHtml() {
      return `
        <div class="customer-survey__resource-stack" style="margin-bottom: 20px;">
          <div>
            <p class="customer-survey__eyebrow">Helpful resources</p>
            <h2 class="customer-survey__question" style="font-size: 28px;">Product tutorials &amp; success stories</h2>
            <p class="customer-survey__description" style="margin-top: 12px;">Review the key product workflows and included features before continuing with your return.</p>
          </div>
          ${this.videoSideHtml({
            title: "Product tutorials",
            subtitle: "3 min",
            thumbnailSrc: imageUrls.app,
            sideTitle: "What's included",
            cards: [
              this.sideCardHtml({ iconName: "flag", title: "Course Play" }),
              this.sideCardHtml({ iconName: "target", title: "Practice Modes" }),
              this.sideCardHtml({ iconName: "chart", title: "Performance Tracking" }),
            ],
          })}
        </div>
      `;
    }

    damageStepHtml() {
      return this.questionFrameHtml({
        motionKey: "damage",
        eyebrow: "Damage details",
        title: "We're Sorry To Hear That",
        description: "What was damaged, defective, or missing?",
        body: `<div class="customer-survey__option-list">${damageOptions
          .map(option =>
            this.optionHtml({
              id: option,
              label: option,
              iconName: "package",
              selected: this.state.damageTypes.includes(option),
              action: "toggle-damage",
            })
          )
          .join("")}</div>`,
      });
    }

    damageDetailsStepHtml() {
      return this.questionFrameHtml({
        motionKey: "damageDetails",
        eyebrow: "A little more context",
        title: "Please provide additional details",
        description: "Upload photos or videos if they help show the issue.",
        body: `
          <textarea class="customer-survey__textarea" data-action="damage-details" rows="6" placeholder="Describe what arrived damaged, defective, or missing...">${escapeHtml(this.state.damageDetails)}</textarea>
          ${this.fileInputHtml({ keyName: "damage", files: this.state.damageFiles, help: "Optional. Images or videos." })}
        `,
      });
    }

    damageResolutionStepHtml() {
      return this.questionFrameHtml({
        motionKey: "damageResolution",
        eyebrow: "Resolution options",
        title: "Would you like us to review your issue and explore a replacement before proceeding with a return?",
        description: "Our team can review the issue before you finalize a return.",
        body: `<div class="customer-survey__option-list">
          ${this.optionHtml({ id: "support", label: "Yes, I'd like support/replacement assistance", iconName: "packageCheck", selected: this.state.damageResolution === "support", action: "damage-resolution" })}
          ${this.optionHtml({ id: "return", label: "No, continue with return", iconName: "thumbsDown", selected: this.state.damageResolution === "return", action: "damage-resolution" })}
        </div>`,
      });
    }

    duplicateInfoHtml() {
      return this.questionFrameHtml({
        motionKey: "duplicateInfo",
        eyebrow: "We understand",
        title: "Duplicate purchases can happen.",
        description: "Continue to the next step when you are ready.",
        body: this.simpleCardHtml("No hassle returns. We will record this as a duplicate product or gift reason."),
      });
    }

    returnItemsHtml() {
      return this.questionFrameHtml({
        motionKey: "returnItems",
        eyebrow: "Return items",
        title: "Which items are you returning?",
        description: "Select everything that will be included in the return package.",
        body: `<div class="customer-survey__option-list">${returnItemOptions
          .map(item =>
            this.optionHtml({
              id: item,
              label: item,
              iconName: "package",
              selected: this.state.returnItems.includes(item),
              action: "toggle-return-item",
            })
          )
          .join("")}</div>`,
      });
    }

    returnPhotosHtml() {
      return this.questionFrameHtml({
        motionKey: "returnPhotos",
        eyebrow: "Photo upload",
        title: "Upload photos of your product",
        description:
          "These photos help us confirm packaging condition before return processing.",
        body: `
          <div class="customer-survey__requirements">
            <p class="customer-survey__requirements-title">Photo requirements:</p>
            <ul class="customer-survey__requirements-list">
              <li>Take a photo showing the mat and tripod unfolded in good condition.</li>
              <li>Take another photo showing the products repacked in the original box.</li>
              <li>Ensure everything is securely resealed with tape and all parts are placed back in the original packaging.</li>
              <li>Include your order number or email address used when you placed your order.</li>
              <li>If the item is unopened, please send a photo of the sealed box.</li>
            </ul>
          </div>
          ${this.fileInputHtml({
            keyName: "return",
            files: this.state.returnFiles,
            title: "Click to upload images or videos",
            help: "Multiple image or video files allowed. Min 1, max 5.",
          })}
        `,
      });
    }

    fileInputHtml({ keyName, files, title = "Click to upload photos or videos", help }) {
      return `
        <label class="customer-survey__file-label" for="${keyName}-survey-files">
          ${icon("upload")}
          <span class="customer-survey__file-title">${escapeHtml(title)}</span>
          <span class="customer-survey__file-help">${escapeHtml(help)}</span>
        </label>
        <input class="customer-survey__file-input" id="${keyName}-survey-files" data-action="${keyName}-files" type="file" accept="image/*,video/*" multiple>
        ${files.length ? `<div class="customer-survey__file-list">${files.map(file => `<div class="customer-survey__file-item">${escapeHtml(file)}</div>`).join("")}</div>` : ""}
      `;
    }

    finalHtml() {
      const isReturn = this.surveyType === "return";
      let title = "";
      let copy = "";
      let next = "";

      if (isReturn) {
        if (this.state.finalChoice === "retain") {
          title = "Product Kept";
        } else if (this.state.finalChoice === "support") {
          title = "Support Review Requested";
        } else {
          title = "Return Request Received";
        }
      } else if (this.state.finalChoice === "retain") {
        title = "Order Kept";
      } else if (this.state.finalChoice === "keep") {
        title = "Order Kept";
      } else {
        title = "Thanks for sharing your feedback";
      }
      copy = "Our support team has received your responses and will update you soon.";
      next = "You can close this page.";

      return `
        <div class="customer-survey__final">
          <div class="customer-survey__final-icon customer-survey__final-icon--success">${icon("check")}</div>
          <p class="customer-survey__eyebrow">Feedback submitted</p>
          <h1 class="customer-survey__final-title">${escapeHtml(title)}</h1>
          <p class="customer-survey__final-copy">${escapeHtml(copy)}</p>
          <p class="customer-survey__final-next">
            ${escapeHtml(next)}<br>
            <span class="customer-survey__final-separator">Or</span>
            <a href="/" class="customer-survey__continue customer-survey__final-website">
              <span class="customer-survey__continue-hover">
                <span class="customer-survey__continue-text">Visit our website</span>
                <span class="customer-survey__continue-icon-wrapper" aria-hidden="true">
                  <span class="customer-survey__continue-icon">${icon("arrowRight")}</span>
                </span>
              </span>
            </a>
          </p>
        </div>
      `;
    }

    footerHtml() {
      if (this.state.step === "final" || this.state.step === "resourceThanks") return "";
      if (this.state.step === "loading" || this.state.step === "state") return "";
      const label = this.state.step === "intro" ? "Start" : "Continue";
      return `
        <footer class="customer-survey__footer">
          <div class="customer-survey__footer-inner">
            <button class="customer-survey__continue" type="button" data-action="continue" ${this.canContinue() ? "" : "disabled"}>
              <span class="customer-survey__continue-hover">
                <span class="customer-survey__continue-text">${this.state.submitting ? "Submitting" : label}</span>
                <span class="customer-survey__continue-icon-wrapper" aria-hidden="true">
                  <span class="customer-survey__continue-icon">${icon("arrowRight")}</span>
                </span>
              </span>
            </button>
          </div>
        </footer>
      `;
    }

    canContinue() {
      const step = this.state.step;
      if (this.state.submitting) return false;
      if (step === "intro") return true;
      if (step === "reason") return Boolean(this.state.reasonId);
      if (step === "resource") return Boolean(this.state.resourceResponse);
      if (step === "resourceThanks") return false;
      if (step === "other") return this.state.otherText.trim().length > 0;
      if (step === "confidence") return this.state.confidenceScore !== null;
      if (step === "notes") return true;
      if (step === "textDetail") return this.state.textDetail.trim().length > 0;
      if (step === "damage") return this.state.damageTypes.length > 0;
      if (step === "damageDetails") return this.state.damageDetails.trim().length > 0;
      if (step === "damageResolution") return Boolean(this.state.damageResolution);
      if (step === "duplicateInfo") return true;
      if (step === "returnItems") return this.state.returnItems.length > 0;
      if (step === "returnPhotos") return this.state.returnFiles.length > 0;
      return true;
    }

    continueFromCurrentStep() {
      const step = this.state.step;
      if (step === "intro") return this.goTo("reason");
      if (step === "reason") return this.continueFromReason();
      if (step === "resource") {
        if (this.isPositiveResourceResponse()) return this.goTo("resourceThanks");
        return this.surveyType === "return" ? this.goTo("offer") : this.goTo("confidence");
      }
      if (step === "other") return this.goTo("confidence");
      if (step === "confidence") return this.goTo("notes");
      if (step === "notes") return this.goTo("offer");
      if (step === "textDetail") return this.goTo("offer");
      if (step === "damage") return this.goTo("damageDetails");
      if (step === "damageDetails") return this.goTo("damageResolution");
      if (step === "damageResolution") {
        if (this.state.damageResolution === "support") {
          return this.setState({ finalChoice: "support", step: "final", history: [...this.state.history, step] });
        }
        return this.goTo("returnItems");
      }
      if (step === "duplicateInfo") return this.goTo("offer");
      if (step === "offer") return undefined;
      if (step === "returnItems") return this.goTo("returnPhotos");
      if (step === "returnPhotos") return this.setState({ finalChoice: "return", step: "final", history: [...this.state.history, step] });
      return undefined;
    }

    continueFromReason() {
      const reason = this.selectedReason();
      if (!reason) return;
      if (this.surveyType === "cancellation") {
        if (reason.resourceTitle) return this.goTo("resource");
        if (reason.textStep) return this.goTo("other");
        return this.goTo("confidence");
      }
      if (reason.resourceTitle) return this.goTo("resource");
      if (reason.id === "damaged") return this.goTo("damage");
      if (reason.id === "duplicate") return this.goTo("duplicateInfo");
      if (reason.textPrompt) return this.goTo("textDetail");
      return this.goTo("offer");
    }

    videoModalHtml() {
      const video = this.state.videoPreview;
      const src = video.videoSrc || this.videoSrc;
      return `
        <div class="customer-survey__modal" role="dialog" aria-modal="true" aria-label="${escapeHtml(video.title)}">
          <button class="customer-survey__modal-scrim" type="button" data-action="close-video" aria-label="Dismiss video preview"></button>
          <div class="customer-survey__modal-panel">
            ${
              src
                ? `<div class="customer-survey__custom-video" data-video-shell>
                    <video class="customer-survey__modal-video" autoplay playsinline muted src="${escapeHtml(src)}" data-video-player>Your browser does not support video playback.</video>
                    <button class="customer-survey__modal-close" type="button" data-action="close-video" aria-label="Close video preview">${icon("x")}</button>
                    <button class="customer-survey__sound-toggle" type="button" data-video-sound-toggle aria-label="Unmute video">
                      <span data-video-sound-icon>${icon("volumeX")}</span>
                    </button>
                    <button class="customer-survey__video-toggle" type="button" data-video-toggle aria-label="Pause video">
                      <span data-video-toggle-icon>${icon("pause")}</span>
                    </button>
                    <div class="customer-survey__video-controls">
                      <div class="customer-survey__video-control-row">
                        <span class="customer-survey__video-time customer-survey__video-time--current" data-video-current-time>0:00</span>
                        <input class="customer-survey__video-seek" type="range" min="0" max="100" step="0.1" value="0" data-video-seek aria-label="Video progress">
                        <span class="customer-survey__video-time customer-survey__video-time--duration" data-video-duration-time>0:00</span>
                      </div>
                    </div>
                  </div>`
                : `<div class="customer-survey__modal-video">
                    <button class="customer-survey__modal-close" type="button" data-action="close-video" aria-label="Close video preview">${icon("x")}</button>
                    <div>
                      <div class="customer-survey__modal-play">${icon("play")}</div>
                      <p class="customer-survey__modal-placeholder">Static placeholder</p>
                      <p class="customer-survey__modal-video-title">${escapeHtml(video.title)}</p>
                    </div>
                  </div>`
            }
          </div>
        </div>
      `;
    }

    bindEvents() {
      this.querySelectorAll("[data-action]").forEach(element => {
        const action = element.getAttribute("data-action");
        if (action === "other-text" || action === "notes-text" || action === "text-detail" || action === "damage-details" || action === "device-model") {
          element.addEventListener("input", event => this.handleInput(action, event));
          if (action === "device-model") {
            element.addEventListener("focus", () => this.openDeviceSuggestions());
            element.addEventListener("blur", () => {
              window.clearTimeout(this.deviceSuggestionTimer);
              this.deviceSuggestionTimer = window.setTimeout(() => this.closeDeviceSuggestions(), 120);
            });
          }
          return;
        }
        if (action === "damage-files" || action === "return-files") {
          element.addEventListener("change", event => this.handleFiles(action, event));
          return;
        }
        if (action === "select-device-suggestion") {
          element.addEventListener("mousedown", event => event.preventDefault());
          element.addEventListener("click", event => this.handleAction(action, event.currentTarget));
          return;
        }
        element.addEventListener("click", event => this.handleAction(action, event.currentTarget));
      });
    }

    bindBrandEvents(brand = this.querySelector("[data-survey-brand]")) {
      if (!brand) return;
      brand.querySelectorAll("[data-action='brand-prev'], [data-action='brand-next']").forEach(element => {
        const action = element.getAttribute("data-action");
        element.addEventListener("click", event => this.handleAction(action, event.currentTarget));
      });
    }

    handleInput(action, event) {
      const value = event.target.value;
      if (action === "other-text") this.state.otherText = value;
      if (action === "notes-text") this.state.notes = value;
      if (action === "text-detail") this.state.textDetail = value;
      if (action === "damage-details") this.state.damageDetails = value;
      if (action === "device-model") {
        this.state.deviceModel = value;
        this.state.deviceResult = "";
        this.state.deviceSuggestionsOpen = true;
        this.updateDeviceSuggestionsDom();
      }
      const footerButton = this.querySelector(".customer-survey__continue");
      if (footerButton) footerButton.disabled = !this.canContinue();
      if (action === "device-model") {
        const checkButton = this.querySelector("[data-action='check-device']");
        if (checkButton) checkButton.disabled = !value.trim();
      }
    }

    handleFiles(action, event) {
      const names = Array.from(event.target.files || []).slice(0, 5).map(file => file.name);
      if (action === "damage-files") this.setState({ damageFiles: names });
      if (action === "return-files") this.setState({ returnFiles: names });
    }

    cancellationSubmitPayload(finalChoice) {
      const reason = this.selectedReason();

      return {
        primary_reason: reason ? reason.label : null,
        resource_feedback: this.state.resourceResponse || null,
        confidence_score: this.state.confidenceScore,
        retention_choice: finalChoice || null,
        other_reason_text: this.state.otherText || null,
        additional_feedback: this.state.notes || null,
        raw_answers_json: {
          primary_reason_id: reason ? reason.id : null,
          resource_response_id: this.state.resourceResponse || null,
          final_choice: finalChoice || null,
          shopify_order_name: this.survey ? this.survey.shopify_order_name : null,
        },
      };
    }

    async submitCancellationSurvey(finalChoice) {
      if (!this.apiBase || !this.token || this.state.submitting) return;

      this.setState({ submitting: true, finalChoice, errorCanRetry: false });

      try {
        const response = await fetch(
          `${this.apiBase}/public/order-cancel-surveys/${encodeURIComponent(this.token)}/submit`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.cancellationSubmitPayload(finalChoice)),
          }
        );
        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          this.state.submitting = false;
          this.renderApiError(response.status, payload);
          return;
        }

        this.survey = getEnvelopeData(payload);
        this.setState({
          submitting: false,
          finalChoice,
          step: "final",
          history: [...this.state.history, this.state.step],
        });
      } catch (error) {
        this.setState({
          submitting: false,
          step: "state",
          errorTitle: "We could not submit this request",
          errorMessage: "Please check your connection and try again.",
          errorCanRetry: true,
        });
      }
    }

    handleAction(action, element) {
      const value = element.getAttribute("data-value");
      if (action === "continue") return this.continueFromCurrentStep();
      if (action === "retry-submit" && this.state.finalChoice) {
        return this.submitCancellationSurvey(this.state.finalChoice);
      }
      if (action === "back") return this.goBack();
      if (action === "brand-prev") return this.setBrandSlide(-1);
      if (action === "brand-next") return this.setBrandSlide(1);
      if (action === "space-carousel-prev") return this.setSpaceSlide(-1);
      if (action === "space-carousel-next") return this.setSpaceSlide(1);
      if (action === "space-carousel-dot") {
        return this.setState({ spaceSlide: Number(value) || 0 });
      }
      if (action === "select-reason") {
        return this.setState({
          reasonId: value,
          resourceResponse: null,
          deviceResult: "",
          textDetail: "",
          damageTypes: [],
          damageResolution: null,
        });
      }
      if (action === "select-resource-response") return this.setState({ resourceResponse: value });
      if (action === "resource-thanks-cancel") return this.goTo("confidence");
      if (action === "select-score") return this.setState({ confidenceScore: Number(value) });
      if (action === "toggle-review") {
        return this.setState({ expandedReview: this.state.expandedReview === value ? null : value });
      }
      if (action === "select-device-suggestion") {
        this.state.deviceSuggestionsOpen = false;
        return this.setState({ deviceModel: value, deviceResult: "" });
      }
      if (action === "check-device") {
        const device = this.state.deviceModel.trim();
        if (!device) return;
        const supportedDevice = this.getSupportedDeviceMatch(device);
        return this.setState({
          deviceResult: supportedDevice
            ? `${supportedDevice} is supported.`
            : "We could not confirm that device. Please choose a supported model from the list.",
        });
      }
      if (action === "open-video") {
        return this.setState({
          videoPreview: {
            title: element.getAttribute("data-video-title") || "Video preview",
            detail: element.getAttribute("data-video-detail") || "Static placeholder.",
            videoSrc: element.getAttribute("data-video-src") || this.videoSrc,
          },
        });
      }
      if (action === "close-video") return this.setState({ videoPreview: null });
      if (action === "final-choice") {
        if (this.surveyType === "cancellation") return this.submitCancellationSurvey(value);
        return this.setState({
          finalChoice: value,
          step: value === "return" ? "returnItems" : "final",
          history: [...this.state.history, this.state.step],
        });
      }
      if (action === "toggle-damage") {
        const next = this.state.damageTypes.includes(value)
          ? this.state.damageTypes.filter(item => item !== value)
          : [...this.state.damageTypes, value];
        return this.setState({ damageTypes: next });
      }
      if (action === "damage-resolution") return this.setState({ damageResolution: value });
      if (action === "toggle-return-item") {
        const next = this.state.returnItems.includes(value)
          ? this.state.returnItems.filter(item => item !== value)
          : [...this.state.returnItems, value];
        return this.setState({ returnItems: next });
      }
    }

    setBrandSlide(delta) {
      const slides = brandSlides[this.surveyType];
      const next = (this.state.activeSlide + delta + slides.length) % slides.length;
      this.state.activeSlide = next;
      const brand = this.querySelector("[data-survey-brand]");
      if (brand) {
        brand.innerHTML = this.renderBrandPanelInner();
        this.bindBrandEvents(brand);
      }
    }

    setSpaceSlide(delta) {
      const total = this.spaceImageSources.length || 1;
      this.setState({
        spaceSlide: (this.state.spaceSlide + delta + total) % total,
      });
    }

    startSpaceCarousel() {
      this.stopSpaceCarousel();
      if (
        this.prefersReducedMotion ||
        this.state.step !== "resource" ||
        this.state.reasonId !== "space" ||
        (this.spaceImageSources.length || 1) <= 1
      ) {
        return;
      }
      this.spaceCarouselTimer = window.setInterval(() => {
        this.setSpaceSlide(1);
      }, 4200);
    }

    stopSpaceCarousel() {
      if (!this.spaceCarouselTimer) return;
      window.clearInterval(this.spaceCarouselTimer);
      this.spaceCarouselTimer = null;
    }

    animateCurrentStep({ skipMotion = false } = {}) {
      const frame = this.querySelector("[data-question-frame]");
      const content = this.querySelector("[data-slide-content]");
      if (!frame || !content) return;
      const title = frame.getAttribute("data-title") || "";
      const motionKey = frame.getAttribute("data-motion-key") || title;
      const textEl = frame.querySelector("[data-question-text]");
      const shouldSkip = skipMotion || this.prefersReducedMotion || this.seenMotionKeys.has(motionKey);

      if (shouldSkip) {
        textEl.textContent = title;
        content.classList.add("is-visible");
        this.seenMotionKeys.add(motionKey);
        return;
      }

      let index = 0;
      const typeNext = () => {
        index += 1;
        textEl.innerHTML = `${escapeHtml(title.slice(0, index))}<span class="customer-survey__cursor"></span>`;
        if (index < title.length) {
          this.timers.push(window.setTimeout(typeNext, QUESTION_TYPING_CHARACTER_DELAY_MS));
          return;
        }
        textEl.textContent = title;
        this.seenMotionKeys.add(motionKey);
        this.timers.push(
          window.setTimeout(() => content.classList.add("is-visible"), CONTENT_SLIDE_AFTER_TYPING_DELAY_MS)
        );
      };

      this.timers.push(window.setTimeout(typeNext, QUESTION_TYPING_START_DELAY_MS));
    }
  }

  if (!customElements.get("customer-survey-flow")) {
    customElements.define("customer-survey-flow", CustomerSurveyFlow);
  }
})();
